import { lazyLoad } from '../../utils/loadable';
export var RootPage = lazyLoad(function () { return import('./Root'); }, function (module) { return module.Root; });
